import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { AdminCatalogState } from "../types/index"
import { initialState } from "./initialState";

const getAdminCatalogState = (state: RootState) => state.AdminCatalogState || initialState


export const selectCatalogs = createSelector(
    [getAdminCatalogState],
    (adminCatalogState: AdminCatalogState) => adminCatalogState.catalogData 

)

export const selectCatalogById = (id: number) => createSelector(
    [getAdminCatalogState],
    (adminCatalogState: AdminCatalogState) =>
        adminCatalogState.catalogData.find((row) => row.id === id)

)

export const selectCatalogItems = createSelector(
    [getAdminCatalogState],
    (adminCatalogState: AdminCatalogState) => adminCatalogState.CatalogItems

)

export const selectCatalogItemById = (id: number) => createSelector(
    [getAdminCatalogState],
    (adminCatalogState: AdminCatalogState) =>
        adminCatalogState.CatalogItems.find((item) => item.id === id)

)

export const selectIsLoading = createSelector(
    [getAdminCatalogState],
    (adminCatalogState: AdminCatalogState) => adminCatalogState.loading   

)

export const selectError = createSelector(
    [getAdminCatalogState],
    (adminCatalogState) => adminCatalogState.error

);
